import { useQuery } from "react-query";
import { AdminJobDetailResponse } from "../../../../models/Job";
import { KandidatResponse } from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import { fetchAllKandidatKey } from "./useFetchAllKandidat";
import ApiClient from "../../../apiClient";

export async function fetchAllTalentPool(): Promise<KandidatResponse[]> {
  const res = await ApiClient.get(`/AllTalentPool`);
  return res.data;
}

export default function useFetchAllTalentPool() {
  return useQuery([fetchAllKandidatKey], queryWrapper(fetchAllTalentPool));
}
